import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as fileSaver from 'file-saver';
import { CoreService } from './core.service';
import { ToastService } from '../toast/toast.service';
import { FileModel } from '../models';
import { b64EncodeUnicode } from '../utilities';


@Injectable({ providedIn: 'root' })

export class FilesManagerService {
  constructor(
    private http: HttpClient,
    private core: CoreService,
    private toasts: ToastService
  ) { }

  // ----------------- DOWNLOAD FILE -----------------
  downloadFile(fileModel: FileModel, name = ''):void {
    this.core.showSplash(true);
    const fileName: string = fileModel.Name;

    this.download(fileModel).subscribe((response: any) => {
      if (response) {
        // code modifié (avec response -> arraybuffer) ---------------------------------------------------------
        let extension: string = fileModel.Extension !== '' ? fileModel.Extension : fileName.split('.').pop() as string;
        if (!extension) {
          this.toasts.showAlertToast(`format de fichier non géré.`);
          this.core.showSplash(false);
          return;
        }
        extension.replace('.', '');
        let fileType: string = '';
        switch (extension) {
          case 'pdf': fileType = 'application/pdf'; break;
          case 'jpg': fileType = 'image/jpg'; break;
          case 'jpeg': fileType = 'image/jpeg'; break;
          case 'png': fileType = 'image/png'; break;
          case 'gif': fileType = 'image/gif'; break;
          case 'xml': fileType = 'application/xml'; break;
          case 'txt': fileType = 'text/plain'; break;
          case 'doc': fileType = 'application/vnd.ms-word'; break;
          case 'docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
          case 'xls': fileType = 'application/vnd.ms-excel'; break;
          case 'xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
          case 'bmp': fileType = 'image/bmp'; break;
          case 'wav': fileType = 'audio/wav'; break;
          case 'ppt': fileType = 'application/vnd.ms-powerpoint'; break;
          case 'pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
          case 'dwg': fileType = 'image/vnd.dwg'; break;
        }
        const blob: Blob = new Blob([(response)], {
          type: fileType,
        });

        if (blob.size > 0) {
          if (window.navigator && (window.navigator.msSaveOrOpenBlob !== undefined || window.navigator.msSaveOrOpenBlob !== null) && (fileType !== 'application/pdf' || fileModel.SaveFile)) {
            // window.navigator.msSaveOrOpenBlob(blob, fileName);
            fileSaver.saveAs(blob, name ? name + '.' + extension: fileName);
          } else {
            // Pour le PDF on l'ouvre dans une nouvelle fenêtre
            // tslint:disable-next-line:typedef
            const objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl);
          }
          // const url = window.URL.createObjectURL(blob);
          //  window.open(url);
        }
        this.core.showSplash(false);
      }
      else {
        this.toasts.showAlertToast(`Le document n'a pas été trouvé sur le serveur`);
        this.core.showSplash(false);
      }

      // --------------------------------------------------------------------------------
    });
  }

  private download(fileModel: FileModel): Observable<any> {
    const data: FileModel = fileModel;
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };

    return this.http.post(`${this.core.AppParams.apiUrl}api/Download`, data, config);
  }

  // upload
  upload(token: string, fileToUpload: File, fileName: string, mode: string): any {
    const fileNameB64: string = b64EncodeUnicode(fileName);
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer',
      headers: { 'Queoval': token, 'mode': mode, 'fileName': fileNameB64 }
    };
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileNameB64);
    formData.append('name', fileNameB64);
    formData.append('mode', mode);
    formData.append('token', this.core.AppParams.token);
    return this.http.post(`${this.core.AppParams.apiUrl}api/Upload`, formData, config);
  }

}
